import { Translation } from 'react-i18next';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { ColumnProps, FollowButton } from '@/components';

import { UserCard } from '@/components/UserCard';

import style from './index.module.scss';
import { BadgeMintRecord } from '../../types';

export const getColumns = (
  setMinterFollower: any,
  currentAddress?: string,
  refetch?: any,
): Array<ColumnProps<BadgeMintRecord>> => [
  {
    title: <Translation>{t => t('MintRecords_columns.12ru4x5')}</Translation>,
    width: '15%',
    sortable: true,
    key: 'inner_id',
    forceSort: true,
    defaultSortOrder: 'asc',
    render: ({ row }) => {
      return <span className={style.innerId}>{`# ${row.inner_id}`}</span>;
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={50} />
      </div>
    ),
  },
  {
    title: <Translation>{t => t('MintRecords_columns.1kpnv')}</Translation>,
    key: 'user.id',
    width: '35%',
    render: ({ row, rowIndex }) => {
      return <UserCard data={row.user.desc} onMemoChange={refetch} />;
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={104} />
      </div>
    ),
  },
  {
    title: <Translation>{t => t('MintRecords_columns.q6o2ej')}</Translation>,
    width: '15%',
    sortable: true,
    key: 'usd_value',
    render: ({ row }) => {
      return <div className={style.netWorth}>{row._networth}</div>;
    },
    forceSort: true,
    skeleton: <Skeleton width={104} />,
  },
  {
    title: (
      <span className={style.tvfWrap}>
        TVF
        <span className={style.followersHeader}>
          <Translation>{t => t('MintRecords_columns.10p5vt0')}</Translation>
        </span>
      </span>
    ),
    width: '15%',
    sortable: true,
    forceSort: true,
    key: 'tvf',
    render: ({ row }) => {
      return (
        <div>
          <div className={style.tvf}>{row._tvf}</div>
          <div className={style.followers}>{row._follows}</div>
        </div>
      );
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={104} />
      </div>
    ),
  },
  {
    title: '',
    width: '15%',
    key: 'operate',
    render: ({ row }) => {
      return currentAddress === row.user.id ? null : (
        <FollowButton
          address={row.user.id}
          userInfo={row.user}
          operateCallback={isFollowing => setMinterFollower({ id: row.id, isFollowing })}
        />
      );
    },
    skeleton: (
      <div className={style.innerCell}>
        <Skeleton width={80} />
      </div>
    ),
  },
];
